var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorfulTagGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0H4C1.79086 0 0 1.79086 0 4V7.5H7.5V0Z",
    fill: "#F491B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16V8.5H0V12C0 14.2091 1.79086 16 4 16H7.5Z",
    fill: "#8CB9DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5H16V12C16 14.2091 14.2091 16 12 16H8.5V8.5Z",
    fill: "#93E08C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.5V0H12C14.2091 0 16 1.79086 16 4V7.5H8.5Z",
    fill: "#FACC2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulTagGroup);
export default __webpack_public_path__ + "static/media/colorfulTagGroup.ca204eba7658115857265db02390a8f1.svg";
export { ForwardRef as ReactComponent };